import gButton from "@/components/g-button/g-button";
import gForm from "@/components/g-form/g-form";
import gCard from "@/components/g-card/g-card.vue"
import gSteps from "@/components/g-steps/g-steps.vue";
import gMenuSidebar from "@/components/g-menu-sidebar/g-menu-sidebar.vue";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import GerarNovoPedidoCaracteristicasViewModel from "@/shared/view-models/GerarNovoPedidoCaracteristicasViewModel";
import ProdutoController from "@/shared/controllers/produto/produtoController"
import Tools from "@/shared/services/tools";
import { useVuelidate } from "@vuelidate/core";
import { helpers, requiredIf } from "@vuelidate/validators";
import PedidoController from "@/shared/controllers/pedido/PedidoController";

const name = 'CaracProduto'
export default {
  name,

  components: {
    'g-form': gForm,
    'g-button': gButton,
    'g-card': gCard,
    'g-steps':gSteps,
    'g-menu-side-bar':gMenuSidebar,
  },

  props: { },

  setup(){
    return {
      v$: useVuelidate()
    }
  },

  validations() {

    if (this.situacaoPedido === 0) {
      const impressao = () =>{

        return((this.CaracteristicasPedido.ImpressaoProvaDeCoresConfeccionar ||
          this.CaracteristicasPedido.ImpressaoPantone ||
          this.CaracteristicasPedido.ImpressaoProvaDeCores ||
          this.CaracteristicasPedido.ImpressaoAmostra ||
          this.CaracteristicasPedido.ImpressaoTemOutros ||
          this.CaracteristicasPedido.ImpressaoEmpresa))
    }

      const visual = () =>{
        return(this.CaracteristicasPedido.VisualAmostra ||
          this.CaracteristicasPedido.VisualTemOutros ||
          this.CaracteristicasPedido.VisualEmpresa ||
          this.CaracteristicasPedido.VisaulArquivo)
      }

      const facaSistema = () =>{
        return (this.CaracteristicasPedido.FacaSistemaAmostra ||
          this.CaracteristicasPedido.FacaSistemaRiscoDeFaca ||
          this.CaracteristicasPedido.FacaSistemaTemOutros ||
          this.CaracteristicasPedido.FacaSistemaPrototipo ||
          this.CaracteristicasPedido.FacaSistemaEmpresa ||
          this.CaracteristicasPedido.FacaSistemaPlanta)
      }

      const facaMedida =() =>{
        return((this.CaracteristicasPedido.FacaMedidaAmostra ||
          this.CaracteristicasPedido.FacaMedidaRiscoDeFaca ||
          this.CaracteristicasPedido.FacaMedidaTemOutros ||
          this.CaracteristicasPedido.FacaMedidaPlanta ||
          this.CaracteristicasPedido.FacaMedidaPrototipo ||
          this.CaracteristicasPedido.FacaMedidaEmpresa))
      }

      // const seloFSC = () => {
      //   if (this.seloFSC === true) {
      //     if (this.CaracteristicasPedido.LocalFSC === '' || this.CaracteristicasPedido.LocalFSC === undefined || this.CaracteristicasPedido.LocalFSC === null)
      //       return false
      //   } else 
      //     return true 
      // }
      
      return{
        // ProgramacaoKanban:  {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Programação Kanban!', programacaoKanban)},
        CaracteristicasPedido:{
          ImpressaoProdutoId  : {required: helpers.withMessage('É necessário selecionar um Produto no menu Impressão!', requiredIf(this.CaracteristicasPedido.ImpressaoEmpresa))},
          VisualProdutoId  : {required: helpers.withMessage('É necessário selecionar um Produto no menu Visual da Embalagem!', requiredIf(this.CaracteristicasPedido.VisualEmpresa))},
          FacaSistemaProdutoId  : {required: helpers.withMessage('É necessário selecionar um Produto no menu Faca / Sistema!', requiredIf(this.CaracteristicasPedido.FacaSistemaEmpresa))},
          FacaMedidaProdutoId  : {required: helpers.withMessage('É necessário selecionar um Produto no menu Faca / Medida!', requiredIf(this.CaracteristicasPedido.FacaMedidaEmpresa))},
          ImpressaoOutros  : {required: helpers.withMessage('É necessário informar um valor para o campo Outros de Impressão!', requiredIf(this.CaracteristicasPedido.ImpressaoTemOutros))},
          DescricaoVisualOutros  : {required: helpers.withMessage('É necessário informar um valor para o campo Outros de Visual da Embalagem!', requiredIf(this.CaracteristicasPedido.VisualTemOutros))},
          FacaSistemaOutros  : {required: helpers.withMessage('É necessário informar um valor para o campo Outros de Faca / Sistema!', requiredIf(this.CaracteristicasPedido.FacaSistemaTemOutros))},
          FacaMedidaOutros  : {required: helpers.withMessage('É necessário informar um valor para o campo Outros de Faca / Medida!', requiredIf(this.CaracteristicasPedido.FacaMedidaTemOutros))},
          ImpressaoNumeroPantone  : {required: helpers.withMessage('É necessário informar um valor para o campo Nº do pantone de Impressão!', requiredIf(this.CaracteristicasPedido.ImpressaoPantone))},
          VisualArquivoDescricao  : {required: helpers.withMessage('É necessário informar um valor para o campo Arquivo Digital de Visual!', requiredIf(this.CaracteristicasPedido.VisaulArquivo))},
          FacaSistemaPrototipoDescricao  : {required: helpers.withMessage('É necessário informar um valor para o campo Protótipo de Faca / Sistema!', requiredIf(this.CaracteristicasPedido.FacaSistemaPrototipo))},
          FacaMedidaPrototipoDescricao  : {required: helpers.withMessage('É necessário informar um valor para o campo Protótipo de Faca / Medida!', requiredIf(this.CaracteristicasPedido.FacaMedidaPrototipo))},

          ImpressaoDescricao  : {required: helpers.withMessage('Ao selecionar mais de um campo do Impressão, torna-se obrigatório preencher a Observação! (mínimo de 10 caracteres)', requiredIf((this.validacaoArray.filter(x=> x === true).length >= 2))) },
          //------------------------------------------------------------------------------------------------------------------------------------------------------
          impressao : {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Impressão!',impressao)},
          visual : {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Visual Embalagem!',visual)},
          facaSistema : {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Faca / Sistema!',facaSistema)},
          facaMedida : {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Faca / Medida!',facaMedida)},
          // seloFSC: {required: helpers.withMessage('É necessário informar um Local de Selo FSC!',seloFSC)},
        }
    }
    }

    if (this.situacaoPedido == 2){
      const impressao = () =>{

        return((this.CaracteristicasPedido.ImpressaoProvaDeCoresConfeccionar ||
          this.CaracteristicasPedido.ImpressaoPantone ||
          this.CaracteristicasPedido.ImpressaoProvaDeCores ||
          this.CaracteristicasPedido.ImpressaoAmostra ||
          this.CaracteristicasPedido.ImpressaoTemOutros ||
          this.CaracteristicasPedido.ImpressaoEmpresa))
    }

      const visual = () =>{
        return(this.CaracteristicasPedido.VisualAmostra ||
          this.CaracteristicasPedido.VisualTemOutros ||
          this.CaracteristicasPedido.VisualEmpresa ||
          this.CaracteristicasPedido.VisaulArquivo)
      }

      // const seloFSC = () => {
      //   if (this.seloFSC === true) {
      //     if (this.CaracteristicasPedido.LocalFSC === '' || this.CaracteristicasPedido.LocalFSC === undefined || this.CaracteristicasPedido.LocalFSC === null || this.CaracteristicasPedido.LocalFSC === "")
      //       return false
      //   } else 
      //     return true 
      // }

      return{
        CaracteristicasPedido:{
          ImpressaoProdutoId  : {required: helpers.withMessage('É necessário selecionar um Produto no menu Impressão!', requiredIf(this.CaracteristicasPedido.ImpressaoEmpresa))},
          VisualProdutoId  : {required: helpers.withMessage('É necessário selecionar um Produto no menu Visual da Embalagem!', requiredIf(this.CaracteristicasPedido.VisualEmpresa))},
          ImpressaoOutros  : {required: helpers.withMessage('É necessário informar um valor para o campo Outros de Impressão!', requiredIf(this.CaracteristicasPedido.ImpressaoTemOutros))},
          DescricaoVisualOutros  : {required: helpers.withMessage('É necessário informar um valor para o campo Outros de Visual da Embalagem!', requiredIf(this.CaracteristicasPedido.VisualTemOutros))},
          ImpressaoNumeroPantone  : {required: helpers.withMessage('É necessário informar um valor para o campo Nº do pantone de Impressão!', requiredIf(this.CaracteristicasPedido.ImpressaoPantone))},
          VisualArquivoDescricao  : {required: helpers.withMessage('É necessário informar um valor para o campo Arquivo Digital de Visual!', requiredIf(this.CaracteristicasPedido.VisaulArquivo))},
          ImpressaoDescricao  : {required: helpers.withMessage('Ao selecionar mais de um campo do Impressão, torna-se obrigatório preencher a Observação! (mínimo de 10 caracteres)', requiredIf((this.validacaoArray.filter(x=> x === true).length >= 2))) },
          //------------------------------------------------------------------------------------------------------------------------------------------------------
          impressao : {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Impressão!',impressao)},
          visual : {required: helpers.withMessage('É necessário selecionar ao menos uma opção do Visual Embalagem!',visual)},
          // seloFSC: {required: helpers.withMessage('É necessário informar um Local de Selo FSC!',seloFSC)},

      }
    }
  }
 },


  mounted () {
    this.getTipoFluxoOrcamento ();
    this.GetTipoOrcamentoAtualByIdIndependenteSequencia();
    this.getCaracteristicas();
    var pedidoId = this.$route.params.id
    this.PedidoId = pedidoId

    EmpresaController.getEmpresasAtivas().requisicao
    .then(response => {
      this.UnidadeArray = response.data.data
      this.atualizaEmpresaRepresentante()
    })
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
    
    this.getSeloFSC()
    this.getSituacaoPedido()
    this.getClienteProgramacao()
    this.ImagemEmpresa()
    this.getTipoPedido()
    this.getkanban()

  },


  updated () { },

  data () {
    return {
      TipoFluxoIndependenteSequencia: '',
      CoresAtivas: false,
      CaracteristicasPedido : new GerarNovoPedidoCaracteristicasViewModel(),
      ProgramacaoKanban: null,
      EhKanban: false,
      ProdutoAll: '',
      codigoProdutoImpressao: '',
      ImpressaoNumeroDoProduto: '',
      VisualNumeroDoProduto: '',
      CodigoFacaSistemaProduto: '',
      CodigoFacaMedidaProduto: '',
      UnidadeArray:[],
      UnidadeImpressao:'',
      UnidadeVisual:'',
      UnidadeSistema:'',
      UnidadeMedida:'',
      ProdutoOpcoesImpressao: [],
      ProdutoOpcoesVisual: [],
      ProdutoOpcoesSistema: [],
      ProdutoOpcoesMedida: [],
      validacaoArray: [],
      TipoFluxo : 0,
      popup: false,
      temAmostraSelecionada: false,
      seloFSC: true,
      situacaoPedido: null,
      clienteProgramacao: null,
      imagemEmpresa: '',
      tipoPedido: null
    }
  },


  methods: {
    camponumero($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
        $event.preventDefault();
      }
    },
    PreencherArquivoNaObs(){
      // if (this.CaracteristicasPedido.DescricaoVisual.includes("///")) {
      //   console.log("A variável contém '///'");
      //   let partes = this.CaracteristicasPedido.DescricaoVisual.split("///");
      //   let textoObservacao = partes[1];
      //   this.CaracteristicasPedido.DescricaoVisual = this.CaracteristicasPedido.VisualArquivoDescricao  + "///" + textoObservacao;
      // } else {
      //   console.log("A variável não contém '///'");
      //   if( this.CaracteristicasPedido.DescricaoVisual ){
      //     let valorObsSemBarra = this.CaracteristicasPedido.DescricaoVisual;
      //     this.CaracteristicasPedido.DescricaoVisual = this.CaracteristicasPedido.VisualArquivoDescricao + "///" + valorObsSemBarra;
      //     }else{
      //       this.CaracteristicasPedido.DescricaoVisual = this.CaracteristicasPedido.VisualArquivoDescricao + '///';
      //     }
      //   }
          //CaracteristicasPedido.VisualArquivoDescricao ISSO É O ARQUIVO DIGITAL
          //CaracteristicasPedido.DescricaoVisual
        },    
    getkanban(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `GerarNovoPedido/GetKanbanClienteByPedidoId/${this.$route.params.id}`,
      })
        .then((response) => {
          this.EhKanban = response.data.data
        })
        .catch(() => {
        });
    },
    ImagemEmpresa(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetNomeEmpresaByPedidoId/${this.$route.params.id}`,
      })
        .then((response) => {

          this.NomeEmpresa=response.data.message

          const nomeEmpresa = () => {
            if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
            if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
            return 'JAUENSE'
          }
  
          const urlBase = window.location.host
          this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
        })
        .catch();
    },

    getTipoFluxoOrcamento() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetTipoOrcamentoAtualById/${this.$route.params.id}`,
      })
        .then((response) => {
          this.PedidoId = response.data.data.id
          this.OrcamentoId = response.data.data.orcamentoId
          this.TipoFluxo = response.data.data.tipoFluxoOrcamento
          this.temAmostraSelecionada = response.data.data.temAmostraSelecionada
          this.ClientePedidoId = response.data.data.clienteId
        })
        .catch(() => {
        });
    },



    GetTipoOrcamentoAtualByIdIndependenteSequencia(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetTipoOrcamentoAtualByIdIndependenteSequencia/${this.$route.params.id}`,
      })
        .then((response) => {

          this.TipoFluxoIndependenteSequencia = response.data.data.tipoFluxoOrcamento

        })
        .catch(() => {
        });
    },


    getDescricaoCorAtivoByPedidoId() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDescricaoCorAtivoByPedidoId/${this.$route.params.id}`,
      })
        .then((response) => {
          this.CoresAtivas = response.data.data
          if(this.CoresAtivas === false){
          this.CaracteristicasPedido.VisualTemOutros = true;
          this.CaracteristicasPedido.ImpressaoTemOutros = true;
          this.CaracteristicasPedido.DescricaoVisualOutros = "SEM IMPRESSÃO"
          this.CaracteristicasPedido.ImpressaoOutros = "SEM IMPRESSÃO"
          }
        })
        .catch(() => {
        });
    },
    getCaracteristicas() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetCaracProduto/${this.$route.params.id}`,
        data: {
          PedidoId: this.$route.params.id
        }
      })
        .then((response) => {
          Tools.objectCustomAssign(this.CaracteristicasPedido, Tools.captalizeKeys(response.data.data))
          this.ProdutoOpcoesImpressao = this.CaracteristicasPedido.ImpressaoProduto
          this.ProdutoOpcoesVisual = this.CaracteristicasPedido.VisualProduto
          this.ProdutoOpcoesSistema = this.CaracteristicasPedido.FacaSistemaProduto
          this.ProdutoOpcoesMedida = this.CaracteristicasPedido.FacaMedidaProduto
          this.validacaoImpressao();
          this.getDescricaoCorAtivoByPedidoId()

        }).finally(() => this.$isLoading(false))
    },

    getTipoPedido() {
      PedidoController.GetTipoPedido(this.$route.params.id).requisicao
        .then((res => {
          this.tipoPedido = res.data.data
        }))
      },


    postCaracProduto() {
      this.$refs.botaoContinuar.isBusy()

      let CaracteristicasProdutoArray = this.CaracteristicasPedido
      
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Pedido/InsertCaracProduto/${this.$route.params.id}`,
        data: CaracteristicasProdutoArray
      })
        .then(() => {
            if(this.tipoPedido === 1){
              this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/pedido-amostra-lote`)
            }else{
              this.$router.push(`/pedido-final/${this.$route.params.id}`)
            }

            setTimeout(() => {
              this.MandarPedidoCRM();
            }, 3000);
        })
        .catch(() => {
        }).finally(this.$refs.botaoContinuar.isBusy);
    },

    MandarPedidoCRM() {      
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/EnviarPedidoCRM/${this.PedidoId}`,
      })
        .then(() => {
        })
        .catch(() => {
        });
    },




    paginafinalizada() {
      this.CaracteristicasPedido.ProgramacaoKanban = this.ProgramacaoKanban
      if (this.temAmostraSelecionada) {
        this.postCaracProduto()
          // this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/pedido-amostra-lote`)
      } else {
        this.postCaracProduto()
          // this.$router.push(`/pedido-final/${this.$route.params.id}`)
      }
  },


    atualizaEmpresaRepresentante() {
      this.UnidadeImpressao = this.$store.state.empresaSelecionadaId;
      this.UnidadeVisual = this.$store.state.empresaSelecionadaId;
      this.UnidadeSistema = this.$store.state.empresaSelecionadaId;
      this.UnidadeMedida = this.$store.state.empresaSelecionadaId;
    },


    buscarProdutosConformeProdutoVisual(pesquisa) {
      this.$isLoading(true)
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
         this.ProdutoOpcoesVisual = ProdutoController.GetProdutoDropDownPedidoCaracteristica(true, false, true, pesquisa, this.UnidadeVisual, this.ClientePedidoId).ProdutoArray;
      this.$isLoading(false)
      }, 1000);
    },

    buscarProdutosConformeProdutoImpressao(pesquisa) {
      this.$isLoading(true)
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoesImpressao = ProdutoController.GetProdutoDropDownPedidoCaracteristica(true, false, true, pesquisa, this.UnidadeImpressao, this.ClientePedidoId).ProdutoArray;
        this.$isLoading(false)
      }, 1000);
    },

    buscarProdutosConformeProdutoSistema(pesquisa) {
      this.$isLoading(true)
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {        
        this.ProdutoOpcoesSistema = ProdutoController.GetProdutoDropDownPedidoCaracteristica(true, false, true, pesquisa, this.UnidadeSistema, this.ClientePedidoId).ProdutoArray;
        this.$isLoading(false)
      }, 1000);
    },

    buscarProdutosConformeProdutoMedida(pesquisa) {
      this.$isLoading(true)
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoOpcoesMedida = ProdutoController.GetProdutoDropDownPedidoCaracteristica(true, false, true, pesquisa, this.UnidadeMedida, this.ClientePedidoId).ProdutoArray;
        this.$isLoading(false)
      }, 1000);
    },


    fecharpopup() {
      this.popup = false
    },


    voltarstep3() {
      this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/produto-em-carregamento-pedido`)
    },


    finalizar() {
      if(this.v$.$invalid){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })
      } 
      
      else if (this.clienteProgramacao === true && this.ProgramacaoKanban === null) {
        this.$toast.add({ severity: 'error', summary: 'É necessário selecionar uma opção do Programação KanBan!', detail: 'Erro', life: 5000 });
      }
      else{
      this.popup = true
        }
    },

    adicionaValidacaoArray(e){
      if(e){
        this.validacaoArray.push(e)
      }else{
        this.validacaoArray.pop(e)
      }
    },

    separaCodigoProdutoImpressao(){
      this.CaracteristicasPedido.ImpressaoNumeroDoProduto = this.separaCodigoProduto(this.ProdutoOpcoesImpressao, this.CaracteristicasPedido.ImpressaoProdutoId)
    },

    separaCodigoProdutoVisual(){
      this.CaracteristicasPedido.VisualNumeroDoProduto = this.separaCodigoProduto(this.ProdutoOpcoesVisual, this.CaracteristicasPedido.VisualProdutoId)
    },

    separaCodigoProdutoSistema(){
      this.CaracteristicasPedido.CodigoFacaSistemaProduto = this.separaCodigoProduto(this.ProdutoOpcoesSistema, this.CaracteristicasPedido.FacaSistemaProdutoId)
    },

    separaCodigoProdutoMedida(){
      this.CaracteristicasPedido.CodigoFacaMedidaProduto = this.separaCodigoProduto(this.ProdutoOpcoesMedida, this.CaracteristicasPedido.FacaMedidaProdutoId)
    },

    separaCodigoProduto(produtoLista, produtoId){
      return produtoLista.filter(x => x.produtoId == produtoId)[0].labelProduto.split('-')[0].trim()
    },

    validacaoImpressao(){
      var impressaoCampos = [this.CaracteristicasPedido.ImpressaoAmostra,
      this.CaracteristicasPedido.ImpressaoProvaDeCores,
      this.CaracteristicasPedido.ImpressaoProvaDeCoresConfeccionar,
      this.CaracteristicasPedido.ImpressaoPantone,
      this.CaracteristicasPedido.ImpressaoTemOutros,
      this.CaracteristicasPedido.ImpressaoEmpresa]

      if(impressaoCampos)
      {
        impressaoCampos.forEach( (e) => {
          if (e){
            e = !false
          }
        })
        this.validacaoArray = impressaoCampos

      }
    },

//------------------------------------------------------------------------------------------------------------------------------------------------
limparCampoArquivoDigital() {
  if (!this.CaracteristicasPedido.VisaulArquivo === false) this.CaracteristicasPedido.VisualArquivoDescricao = null
},

limparCampoPantone() {
  if (!this.CaracteristicasPedido.ImpressaoPantone === false) this.CaracteristicasPedido.ImpressaoNumeroPantone = null
},

limparCampoPrototipoSistema() {
  if (!this.CaracteristicasPedido.FacaSistemaPrototipo == false) this.CaracteristicasPedido.FacaSistemaPrototipoDescricao = null
},

limparCampoPrototipoMedida() {
  if (!this.CaracteristicasPedido.FacaMedidaPrototipo == false) this.CaracteristicasPedido.FacaMedidaPrototipoDescricao = null
},

limparCampoOutrosImpressao() {
  if (!this.CaracteristicasPedido.ImpressaoTemOutros === false) this.CaracteristicasPedido.ImpressaoOutros = null
},

limparCampoOutrosVisual() {
  if (!this.CaracteristicasPedido.VisualTemOutros === false) this.CaracteristicasPedido.DescricaoVisualOutros = null
},

limparCampoOutrosMedida() {
  if (!this.CaracteristicasPedido.FacaMedidaTemOutros === false) this.CaracteristicasPedido.FacaMedidaOutros = null
},

limparCampoOutrosSistema() {
  if (!this.CaracteristicasPedido.FacaSistemaTemOutros === false) this.CaracteristicasPedido.FacaSistemaOutros = null
},

limparCampoEmpresaImpressao(){
  if (!this.CaracteristicasPedido.ImpressaoEmpresa === false) this.CaracteristicasPedido.ImpressaoProdutoId = null
},

limparCampoEmpresaVisual(){
  if (!this.CaracteristicasPedido.VisualEmpresa === false) this.CaracteristicasPedido.VisualProdutoId = null
},

limparCampoEmpresaSistema(){
  if (!this.CaracteristicasPedido.FacaSistemaEmpresa === false) this.CaracteristicasPedido.FacaSistemaProdutoId = null
},

limparCampoEmpresaMedida(){
  if (!this.CaracteristicasPedido.FacaMedidaEmpresa === false) this.CaracteristicasPedido.FacaMedidaProdutoId = null
},


//----------------------------------------------------------------------
ValidacaoPrototipo(){
  if(this.CaracteristicasPedido.FacaSistemaPrototipo){
    this.CaracteristicasPedido.FacaSistemaAmostra = false
    this.CaracteristicasPedido.FacaSistemaRiscoDeFaca = false
    this.CaracteristicasPedido.FacaSistemaPlanta = false
    this.CaracteristicasPedido.FacaSistemaTemOutros = false
  }else(!this.CaracteristicasPedido.FacaSistemaPrototipo)
  this.CaracteristicasPedido.FacaSistemaPrototipoDescricao = null
},

  ValidacaoAmostra(){
  if(this.CaracteristicasPedido.FacaSistemaAmostra){
    this.CaracteristicasPedido.FacaSistemaRiscoDeFaca = false
    this.CaracteristicasPedido.FacaSistemaPlanta = false
    this.CaracteristicasPedido.FacaSistemaPrototipo = false
    this.CaracteristicasPedido.FacaSistemaTemOutros = false
  }
},

ValidacaoRisco(){
  if(this.CaracteristicasPedido.FacaSistemaRiscoDeFaca){
    this.CaracteristicasPedido.FacaSistemaAmostra = false
    this.CaracteristicasPedido.FacaSistemaPlanta = false
    this.CaracteristicasPedido.FacaSistemaPrototipo = false
    this.CaracteristicasPedido.FacaSistemaTemOutros = false
  }
},

ValidacaoPlanta(){
  if(this.CaracteristicasPedido.FacaSistemaPlanta){
    this.CaracteristicasPedido.FacaSistemaRiscoDeFaca = false
    this.CaracteristicasPedido.FacaSistemaAmostra = false
    this.CaracteristicasPedido.FacaSistemaPrototipo = false
    this.CaracteristicasPedido.FacaSistemaTemOutros = false
}
},

ValidacaoFacaSistemaTemOutros(){
  if(this.CaracteristicasPedido.FacaSistemaTemOutros){
    this.CaracteristicasPedido.FacaSistemaRiscoDeFaca = false
    this.CaracteristicasPedido.FacaSistemaAmostra = false
    this.CaracteristicasPedido.FacaSistemaPrototipo = false
    this.CaracteristicasPedido.FacaSistemaPlanta = false
  }else(!this.CaracteristicasPedido.FacaSistemaTemOutros)
  this.CaracteristicasPedido.FacaSistemaOutros = null
  },

//----------------------------------------------------------------------
ValidacaoPrototipoMedida(){
if(this.CaracteristicasPedido.FacaMedidaPrototipo){
  this.CaracteristicasPedido.FacaMedidaAmostra = false
  this.CaracteristicasPedido.FacaMedidaRiscoDeFaca = false
  this.CaracteristicasPedido.FacaMedidaPlanta = false
  this.CaracteristicasPedido.FacaMedidaTemOutros = false
}else(!this.CaracteristicasPedido.FacaMedidaPrototipo)
this.CaracteristicasPedido.FacaMedidaPrototipoDescricao = null
},

ValidacaoAmostraMedida(){
if(this.CaracteristicasPedido.FacaMedidaAmostra){
  this.CaracteristicasPedido.FacaMedidaRiscoDeFaca = false
  this.CaracteristicasPedido.FacaMedidaPlanta = false
  this.CaracteristicasPedido.FacaMedidaPrototipo = false
  this.CaracteristicasPedido.FacaMedidaTemOutros = false
}
},

ValidacaoRiscoMedida(){
if(this.CaracteristicasPedido.FacaMedidaRiscoDeFaca){
  this.CaracteristicasPedido.FacaMedidaAmostra = false
  this.CaracteristicasPedido.FacaMedidaPlanta = false
  this.CaracteristicasPedido.FacaMedidaPrototipo = false
  this.CaracteristicasPedido.FacaMedidaTemOutros = false
}
},

ValidacaoPlantaMedida(){
if(this.CaracteristicasPedido.FacaMedidaPlanta){
  this.CaracteristicasPedido.FacaMedidaRiscoDeFaca = false
  this.CaracteristicasPedido.FacaMedidaAmostra = false
  this.CaracteristicasPedido.FacaMedidaPrototipo = false
  this.CaracteristicasPedido.FacaMedidaTemOutros = false
}
},

ValidacaoFacaMedidaTemOutros(){
  if(this.CaracteristicasPedido.FacaMedidaTemOutros){
    this.CaracteristicasPedido.FacaMedidaRiscoDeFaca = false
    this.CaracteristicasPedido.FacaMedidaAmostra = false
    this.CaracteristicasPedido.FacaMedidaPrototipo = false
    this.CaracteristicasPedido.FacaMedidaPlanta = false
  }else(!this.CaracteristicasPedido.FacaMedidaTemOutros)
  this.CaracteristicasPedido.FacaMedidaOutros = null
  },

  getSeloFSC() {
    PedidoController.GetSeloFSC(this.$route.params.id).requisicao
      .then((res => {
        this.seloFSC = res.data.data
      }))
  },
  
  getSituacaoPedido() {
    PedidoController.GetSituacaoPedido(this.$route.params.id).requisicao
      .then((res => {
        this.situacaoPedido = res.data.data
      }))
    },
    getClienteProgramacao() {
      PedidoController.GetClienteProgramacao(this.$route.params.id).requisicao
        .then((res => {
          this.clienteProgramacao = res.data.data
        }))
    }


},

//----------------------------------------------------------------------

  computed: { },

};

